import { IKeyValueInterface, RoleLevel } from "./../../shared/config";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { VehicleAttributeCategoryModel } from "../models/vehicleattributecategory.model";
import { VehicleAttributeCategoryService } from "../models/vehicleattributecategory.service";
import { InstanceService } from "../../instance/models/instance.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  PermissionType
} from "../../shared/config";
import { Location } from "@angular/common";
import { DropdownModel } from "../../report/models/report-filter.model";

@Component({
  selector: "wego-vehicleattributecategory-update",
  template: require('../views/vehicleattributecategory-update.component.html'),
  providers: [VehicleAttributeCategoryService, InstanceService]
})
export class VehicleAttributeCategoryUpdateComponent
  implements OnInit, OnDestroy {
  vehicleAttributeCategoryHashId: string;
  sub: any;
  submitted = false;
  model: VehicleAttributeCategoryModel;
  apiResponse: IAPIResponse;
  errorModel: IKeyValueInterface[];
  instanceList: DropdownModel[];
  errorMessage: string;
  message: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlVehicleAttributeCategoryList: string;
  pageName: string;
  accessDeniedErrorCode: string;
  roleLevel = RoleLevel;

  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;

  @ViewChild("alertModal") public alertModal: any;
  @ViewChild("successPopup") public successPopup: any;

  constructor(
    private vehicleAttributeCategoryService: VehicleAttributeCategoryService,
    private instanceService: InstanceService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location
  ) {}

  ngOnInit() {
    this.pageName = "Vehicle_Attribute_Category";
    this.accessDeniedErrorCode = "412";
    this.module = this.translate.instant("LblVehicleAttributeCategory");
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlVehicleAttributeCategoryList = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_LIST
    );
    this.model = new VehicleAttributeCategoryModel();
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
    this.sub = this.activeRoute.params.subscribe(params => {
      let vehicleAttributeCategryHashId = params["id"] || "";
      if (vehicleAttributeCategryHashId != "") {
        this.GetInstanceListDropdown(PermissionType.EDIT);
      } else {
        this.GetInstanceListDropdown(PermissionType.INSERT);
      }
    });
  }

  public GetVehicleAttributeCategoryDetails() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.vehicleAttributeCategoryHashId = params["id"] || "";
      if (this.vehicleAttributeCategoryHashId != "") {
        this.isEditMode = true;
        this.vehicleAttributeCategoryService
          .GetVehicleAttributeCategoryByHashId(
            this.vehicleAttributeCategoryHashId
          )
          .subscribe(
            res => (this.model = res.data),
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            }
          );
      } else {
        this.isEditMode = false;
      }
      this.breadCrumbTitle = this.isEditMode
        ? this.translate.instant("LblEditPage", [this.module])
        : this.translate.instant("LblAddPage", [this.module]);
    });
  }

  onSubmit(forms: any) {
    this.submitted = true;
    this.AddNewVehicleCategoryAttribute(JSON.stringify(this.model));
  }

  public GetInstanceListDropdown(permissionType: string) {
    this.instanceService
      .GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType)
      .subscribe(
        res => {
          this.apiResponse = res;
          this.instanceList = res.data;
          if (this.instanceList.length == 0) {
            this.authService.HandleErrorStatusCode(this.accessDeniedErrorCode);
          }

          if (this.instanceList && this.instanceList.length > 0) {
            if (!this.model.instanceHashId && this.instanceList.length == 1) {
              this.model.instanceHashId = this.instanceList[0].keyHash;
            }
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        },
        () => this.GetVehicleAttributeCategoryDetails()
      );
  }
  public AddNewVehicleCategoryAttribute(formData: any) {
    this.vehicleAttributeCategoryService
      .AddNewVehicleAttributeCategory(formData)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.isEditMode
              ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
              : this.translate.instant("LblRecordAddedSuccess", [this.module]);
            this.ShowSuccessPopup();
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public onChangeSelectedField(value: any): void {
    this.model.instanceHashId = value;
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle-attribute-category/components/vehicleattributecategory-update.component.ts